import { BaseKey, useApiUrl, useCustomMutation } from '@refinedev/core';
import { getUserInfoFromCache } from 'utility/helper';

interface VectorySyncData {
  productIds: BaseKey[];
}

export const useVectorySync = () => {
  const apiUrl = useApiUrl();
  const { mutate } = useCustomMutation();
  const userInfo = getUserInfoFromCache();

  const syncProductsToVectory = (input: VectorySyncData) => {
    mutate({
      url: `${apiUrl}/actions/vectory-synchronize`,
      method: "post",
      successNotification: () => {
        return {
          message: "",
          description: "Synk till sökmotor startades",
          type: "success",
        };
      },
      values: {
        ids: input.productIds,
      },
      config: {
        headers: { Authorization: `Bearer ${userInfo.token}` }
      }
    });
  };

  return { syncProductsToVectory };
};
